import React from 'react'
import classNames from 'classnames'
import { CaptionMD, CaptionSM } from '@/atoms/Text'
import { Translate, useTranslate } from '@/utils/translate/translate-client'

export type Tab = 'annual' | 'monthly'
interface FrequencySelectorProps {
  onClick: (tab: Tab) => void
  tabPosition: Tab
  darkMode: boolean
}
export const FrequencySelectorGeneral: React.FC<FrequencySelectorProps> = ({
  onClick,
  tabPosition,
  darkMode = false,
}) => {
  const { t } = useTranslate('guild')

  return (
    <div
      className={classNames(
        'relative mb-10 mx-auto block h-[58px] w-full cursor-pointer rounded-full border-2  px-[2px] py-1 max-w-[312px]',
        { 'border-core-gray-600 bg-core-gray-800': darkMode, 'border-core-gray-400 bg-core-gray-300': !darkMode },
      )}
      style={{ WebkitTapHighlightColor: 'transparent' }}
    >
      <div
        className={classNames(
          'w-1/2 absolute h-[48px] top-1/2 -translate-y-1/2 bg-white rounded-full shadow-sm transform cursor-pointer transition-all duration-400 transition-timing-function-.22,.68,0,1.71 mx-0.5',
          {
            'translate-x-[0%]': tabPosition == 'monthly',
            'translate-x-[95%]': tabPosition == 'annual',
          },
        )}
      />
      <div className="absolute top-0 flex h-full w-full items-center justify-center px-2">
        <div className="flex h-full w-1/2 flex-col items-center justify-center" onClick={() => onClick('monthly')}>
          <CaptionMD
            weight="bold"
            className="duration-400 select-none transition-all ease-in-out"
            color={tabPosition === 'monthly' || !darkMode ? 'core-gray-950' : 'white'}
          >
            <Translate i18nKey="monthly" t={t}>
              Monthly
            </Translate>
          </CaptionMD>
        </div>
        <div
          className="flex h-full w-1/2 flex-col items-center justify-center pl-0 pr-2"
          onClick={() => onClick('annual')}
        >
          <CaptionMD
            weight="bold"
            className="duration-400 select-none transition-all ease-in-out"
            color={tabPosition === 'annual' || !darkMode ? 'core-gray-950' : 'white'}
          >
            <Translate t={t} i18nKey="yearly">
              Yearly
            </Translate>
          </CaptionMD>
          <CaptionSM
            className={classNames('-mt-[1.5px] select-none italic !text-oxide-primary', {
              '!text-oxide-bright': darkMode && tabPosition === 'monthly',
            })}
            weight="bold"
            color="core-gray-500"
          >
            {t('saveUpTo25%', 'Save up to 25%')}
          </CaptionSM>
        </div>
      </div>
    </div>
  )
}
